<template>
  <div
    class="bg-primary container-fluid h-100 d-flex align-items-center justify-content-center"
    style="min-height: calc(100vh - 5rem)"
    data-cy="pagamento-cartao-bg-container"
  >
    <negociacao-nao-encontrada-erro
      :show="!negociacao"
      @voltar="cancel()"
      data-cy="pagamento-cartao-negociacao-erro"
    />

    <div
      class="col-md-10 col-lg-10 col-xl-10"
      v-if="negociacao"
      data-cy="pagamento-cartao-main-col"
    >
      <div class="card rounded-0" data-cy="pagamento-cartao-card">
        <div class="card-body p-lg-5" data-cy="pagamento-cartao-card-body">
          <fieldset
            :disabled="loading"
            v-if="!pagamento_finalizado"
            data-cy="pagamento-cartao-fieldset"
          >
            <div
              class="text-center mb-4"
              data-cy="pagamento-cartao-title-container"
            >
              <h4
                class="text-primary font-weight-bold"
                data-cy="pagamento-cartao-title"
              >
                Informações para o Pagamento
              </h4>
            </div>
            <b-form
              @submit.stop.prevent="submeterFormulario($event)"
              class="needs-validation"
              novalidate
              data-cy="pagamento-cartao-form"
            >
              <b-row data-cy="pagamento-cartao-row-valor">
                <b-col
                  md="3"
                  sm="12"
                  class="mt-1"
                  data-cy="pagamento-cartao-col-valor"
                >
                  <strong data-cy="pagamento-cartao-label-valor">
                    Valor Total
                    <span
                      class="text-success"
                      data-cy="pagamento-cartao-span-valor"
                    >
                      {{ (negociacao && negociacao.valor) | currency }}
                    </span>
                  </strong>
                </b-col>
              </b-row>

              <b-row data-cy="pagamento-cartao-row-form">
                <b-col
                  xl="4"
                  lg="6"
                  md="6"
                  sm="12"
                  class="mt-1"
                  data-cy="pagamento-cartao-col-nome-cartao"
                >
                  <label
                    for="nomeCartao"
                    v-required
                    data-cy="pagamento-cartao-label-nome-cartao"
                  >
                    Nome (Impresso no Cartão)
                  </label>
                  <b-form-input
                    class="form-control text-uppercase"
                    type="text"
                    ref="nomeCartao"
                    v-model="form.nomeCartao"
                    :state="validation.nomeCartao"
                    id="nomeCartao"
                    required
                    maxlength="30"
                    trim
                    autocomplete="off"
                    placeholder="Nome"
                    data-cy="pagamento-cartao-input-nome-cartao"
                  />
                </b-col>

                <b-col
                  xl="4"
                  lg="6"
                  md="6"
                  sm="12"
                  class="mt-1"
                  data-cy="pagamento-cartao-col-numero-cartao"
                >
                  <label
                    for="nome"
                    v-required
                    data-cy="pagamento-cartao-label-numero-cartao"
                  >
                    Número do Cartão
                  </label>
                  <b-form-input
                    class="form-control"
                    type="text"
                    ref="card"
                    :state="validation.numeroCartao"
                    v-model="form.numeroCartao"
                    @keyup="numeroCartaoChange($event)"
                    id="cardNumber"
                    required
                    v-mask="[`#### #### #### ####`]"
                    placeholder="Número do Cartão"
                    data-cy="pagamento-cartao-input-numero-cartao"
                  />
                </b-col>

                <b-col
                  lg="4"
                  md="6"
                  sm="12"
                  class="mt-1"
                  data-cy="pagamento-cartao-col-bandeira"
                >
                  <label
                    for="bandeira"
                    v-required
                    data-cy="pagamento-cartao-label-bandeira"
                  >
                    Bandeira
                  </label>
                  <b-form-select
                    id="bandeira"
                    v-model="form.bandeiraCartao"
                    :state="validation.bandeiraCartao"
                    required
                    data-cy="pagamento-cartao-select-bandeira"
                  >
                    <option
                      :value="null"
                      disabled
                      hidden
                      data-cy="pagamento-cartao-option-bandeira-null"
                    >
                      -- Selecione --
                    </option>
                    <option
                      v-for="bandeira in bandeiras"
                      :value="bandeira"
                      :key="bandeira"
                      :data-cy="`pagamento-cartao-option-bandeira-${bandeira}`"
                      >{{ bandeira }}
                    </option>
                  </b-form-select>
                </b-col>

                <b-col
                  lg="4"
                  md="6"
                  sm="12"
                  class="mt-1"
                  data-cy="pagamento-cartao-col-codigo"
                >
                  <label
                    for="codigo"
                    v-required
                    data-cy="pagamento-cartao-label-codigo"
                  >
                    Cód. de Segurança
                  </label>
                  <b-form-input
                    class="form-control"
                    type="text"
                    ref="codigo"
                    :state="validation.cvv"
                    v-model="form.cvv"
                    id="codigo"
                    placeholder="CVV"
                    v-mask="[`###`]"
                    required
                    autocomplete="off"
                    data-cy="pagamento-cartao-input-codigo"
                  />
                </b-col>

                <b-col
                  lg="4"
                  md="6"
                  sm="12"
                  class="mt-1"
                  data-cy="pagamento-cartao-col-validade"
                >
                  <label
                    for="mes"
                    v-required
                    data-cy="pagamento-cartao-label-validade"
                  >
                    Validade
                  </label>
                  <b-form-input
                    :state="validation.validade"
                    v-model="form.validade"
                    @change="validadeChange()"
                    placeholder="MM/AA"
                    v-mask="[`##/##`]"
                    required
                    data-cy="pagamento-cartao-input-validade"
                  >
                  </b-form-input>
                </b-col>
              </b-row>

              <hr
                class="mt-3 mb-2"
                data-cy="pagamento-cartao-hr-dados-contato"
              />

              <dados-e-contato
                :form="form"
                :validation="validation"
                data-cy="pagamento-cartao-dados-contato"
              ></dados-e-contato>

              <hr class="mt-3 mb-2" data-cy="pagamento-cartao-hr-endereco" />

              <endereco
                :form="form"
                :validation="validation"
                data-cy="pagamento-cartao-endereco"
              ></endereco>

              <div
                class="w-100 d-flex justify-content-between mt-2"
                data-cy="pagamento-cartao-btn-row"
              >
                <b-button
                  variant="white"
                  class="btn-outline-primary rounded-0"
                  @click="cancel()"
                  data-cy="pagamento-cartao-btn-cancelar"
                >
                  <strong data-cy="pagamento-cartao-btn-cancelar-label">
                    <font-awesome-icon
                      :icon="['fas', 'times']"
                      data-cy="pagamento-cartao-btn-cancelar-icon"
                    ></font-awesome-icon>
                    Cancelar
                  </strong>
                </b-button>
                <b-button
                  variant="primary"
                  class="rounded-0"
                  type="submit"
                  data-cy="pagamento-cartao-btn-finalizar"
                >
                  <strong data-cy="pagamento-cartao-btn-finalizar-label">
                    <font-awesome-icon
                      v-if="loading"
                      class="fa-spin"
                      :icon="['fa', 'circle-notch']"
                      data-cy="pagamento-cartao-btn-finalizar-icon-loading"
                    ></font-awesome-icon>

                    <font-awesome-icon
                      v-if="!loading"
                      :icon="['fas', 'money-check-alt']"
                      data-cy="pagamento-cartao-btn-finalizar-icon"
                    ></font-awesome-icon>
                    <span
                      v-if="!loading"
                      data-cy="pagamento-cartao-btn-finalizar-span"
                    >
                      Finalizar pagamento
                    </span>
                    <span
                      v-if="loading"
                      data-cy="pagamento-cartao-btn-finalizar-span-loading"
                    >
                      Processando pagamento
                    </span>
                  </strong>
                </b-button>
              </div>
            </b-form>
          </fieldset>
          <div
            class="m-5 text-center"
            v-if="pagamento_finalizado"
            data-cy="pagamento-cartao-finalizado-container"
          >
            <font-awesome-icon
              size="10x"
              class="text-success"
              :icon="['far', 'check-circle']"
              data-cy="pagamento-cartao-finalizado-icon"
            ></font-awesome-icon>

            <div
              class="col-6 offset-3"
              data-cy="pagamento-cartao-finalizado-col"
            >
              <router-link
                :to="{
                  name: 'index',
                  params: { organizationId: $route.params.organizationId }
                }"
                class="btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center my-3"
                data-cy="pagamento-cartao-finalizado-link"
              >
                Pagamento realizado com sucesso!
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { genders, validCPF, validEmail } from "@/core/enumHelper";
import { creditCardType } from "@/core/util/credit-cart-type";
import { mask } from "vue-the-mask";
import { axiosInstance as Axios } from "@/main";
import { mapGetters } from "vuex";
import Endereco from "@/views/endereco";
import DadosEContato from "@/views/dadosEContato";
import NegociacaoNaoEncontradaErro from "@/views/negociacaoNaoEncontradaErro";

const requiredFields = {
  nomeCartao: null,
  bandeiraCartao: null,
  validade: null,
  cpf: null,
  numeroCartao: null,
  email: null,
  telefonePrincipal: null,
  uf: null,
  cep: null,
  rua: null,
  numero: null,
  bairro: null,
  cvv: null,
  cidade: null
};

export default {
  name: "pagamentoCartao",
  components: { NegociacaoNaoEncontradaErro, DadosEContato, Endereco },
  directives: { mask },
  data() {
    return {
      negociacao: null,
      loading: false,
      form: {
        numeroParcela: 1,
        anoExpiracao: null,
        mesExpiracao: null,
        ...requiredFields
      },
      validation: {},
      bandeiras: [
        "Visa",
        "Mastercard",
        "Elo",
        "Hipercard",
        "Amex",
        "Aura",
        "JCB",
        "Diners",
        "Discover"
      ],
      pagamento_finalizado: false
    };
  },
  computed: {
    genders() {
      return Object.values(genders);
    },
    type() {
      return this.$store.getters.type;
    },
    usuario() {
      return this.$store.getters.user;
    },
    agendamento() {
      return this.$store.getters.get_agendamento;
    },
    ...mapGetters(["get_selected", "token"])
  },
  async mounted() {
    const valor = this.get_selected.find(it => it.stepId === 2).valor;
    this.negociacao = valor ? { valor } : null;

    this.form.nomeCartao = this.usuario.nome;
    this.form.cpf =
      this.usuario.tipoDocumento === "CPF"
        ? this.usuario.numeroDocumento
        : null;
    this.form.telefonePrincipal = this.usuario.telefonePrincipal;
    this.form.email = this.usuario.email;

    const payload = {
      name: "finish",
      params: { organizationId: this.$route.params.organizationId },
      query: {
        ...(localStorage.getItem("telemedicina")
          ? { telemedicina: localStorage.getItem("telemedicina") }
          : {})
      }
    };

    await this.$store.dispatch("set_to", payload);
    await this.$store.dispatch("set_from", payload);

    await this.$store.dispatch("set_actual", this.$route.fullPath);

    const agendaId = this.get_selected[3].agendaId;

    const negociacao = await Axios.post(
      `${this.$serverHost}agendamentos/negociacao/${agendaId}`,
      {
        agendaId: this.get_selected[3].agendaId
      },
      {
        headers: {
          "X-Organizacao-ID": this.$route.params.organizationId
        },
        params: {
          convenio_id: this.agendamento.convenio.id,
          especialidade_id: this.agendamento.especialidade.id,
          procedimento_id: this.agendamento.procedimento.id,
          clinica_id: this.agendamento.clinica.id
        }
      }
    );

    this.negociacao = negociacao.data;
  },
  methods: {
    validadeChange() {
      const form = this.form;

      const [mesExpiracao, digitosAnoExpiracao] = form.validade
        .split("/")
        .map(it => parseInt(it));

      form.anoExpiracao = 2000 + digitosAnoExpiracao;
      form.mesExpiracao = mesExpiracao;
    },
    numeroCartaoChange() {
      const numerosCartao = (this.form.numeroCartao || "").replace(/\D/g, "");

      if (!numerosCartao) {
        this.form.bandeiraCartao = null;
        return;
      }

      if (!this.form.bandeiraCartao && numerosCartao.length >= 4) {
        const bandeira = creditCardType(numerosCartao);

        if (this.bandeiras.indexOf(bandeira) >= 0) {
          this.form.bandeiraCartao = bandeira;
        }
      }
    },
    cancel() {
      this.$router.push(this.$store.getters.from);
    },
    validateRequired(form) {
      const validation = {};

      Object.keys(requiredFields).forEach(fieldName => {
        validation[fieldName] = !!form[fieldName];
      });

      return validation;
    },
    validateSpecificRules(form) {
      const validation = {};

      const hoje = new Date();
      const anoAtual = hoje.getFullYear();
      const mesAtual = hoje.getMonth() + 1;

      const nomeCartao = form.nomeCartao || "";
      const cpf = (form.cpf || "").replace(/\D/g, "");
      const cep = (form.cep || "").replace(/\D/g, "");
      const numeroCartao = (form.numeroCartao || "").replace(/\D/g, "");
      const cvv = (form.cvv || "").replace(/\D/g, "");
      const telefonePrincipal = (form.telefonePrincipal || "").replace(
        /\D/g,
        ""
      );
      const validade = form.validade || "";

      const [mesExpiracao, digitosAnoExpiracao] = validade
        .split("/")
        .map(it => parseInt(it));
      const anoExpiracao = 2000 + digitosAnoExpiracao;

      if (
        !anoExpiracao ||
        !mesExpiracao ||
        mesExpiracao > 12 ||
        anoExpiracao < anoAtual ||
        (anoExpiracao === anoAtual && mesExpiracao < mesAtual)
      ) {
        validation.validade = false;
      }

      validation.nomeCartao = nomeCartao.length <= 30;

      validation.email = validEmail(form.email);
      validation.cpf = validCPF(cpf);

      validation.cep = cep.length === 8;
      validation.telefonePrincipal = telefonePrincipal.length >= 10;
      validation.cvv = cvv.length === 3;
      validation.numeroCartao = numeroCartao.length >= 13;

      return validation;
    },
    async submeterFormulario() {
      const form = this.form;

      this.validation = {
        ...this.validateRequired(form),
        ...this.validateSpecificRules(form)
      };

      const fields = Object.entries(this.validation);
      const invalidField = fields.filter(([, valid]) => !valid);

      if (invalidField.length > 0) {
        console.log(invalidField);

        this.$bvToast.toast(
          "Alguns dados informados estão incompletos, por favor corrija-os e tente novamente.",
          {
            title: "Dados incompletos",
            autoHideDelay: 10000,
            variant: "danger"
          }
        );

        return;
      }

      const dadosCartao = {
        nomeTitular: form.nomeCartao,
        numeroCartao: form.numeroCartao,
        bandeira: form.bandeiraCartao,
        mesExpiracao: form.mesExpiracao,
        anoExpiracao: form.anoExpiracao,
        codigoSeguranca: form.cvv,
        valorPago: this.negociacao.valor,
        numeroParcelas: form.numeroParcela
      };
      const endereco = {
        uf: form.uf,
        cep: form.cep,
        pais: "Brasil",
        bairro: form.bairro,
        logradouro: form.rua,
        numero: form.numero,
        localidade: form.cidade
      };
      const dadosPessoais = {
        cpfCnpj: form.cpf,
        nome: form.nomeCartao,
        email: form.email,
        telefone: form.telefonePrincipal,
        endereco
      };

      this.loading = true;

      try {
        const response = await Axios.post(
          `${this.$serverHost}protected/pagamento`,
          {},
          {
            headers: {
              "X-Organizacao-ID": this.$route.params.organizationId,
              Authorization: `Bearer ${this.token}`
            },
            params: {},
            data: {
              marcacaoId: this.agendamento.id,
              dadosCartao,
              dadosPessoais
            }
          }
        );

        if (response.status === 200) {
          this.pagamento_finalizado = true;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    clear() {
      this.form = {};
      this.validation = {};
    }
  }
};
</script>

<style scoped></style>
